var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_14265",
    "data-name": "Group 14265",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13382",
    "data-name": "Path 13382",
    d: "M43.38,51.035l-1.865-1.85L40.5,50.192l2.88,2.857,5.76-5.714-1.015-1.007Z",
    transform: "translate(-31.14 -33.049)",
    fill: "#868a97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13383",
    "data-name": "Path 13383",
    d: "M25.65,6.643H23.49V5.929A1.439,1.439,0,0,0,22.05,4.5H16.29a1.439,1.439,0,0,0-1.44,1.429v.714H12.69a1.439,1.439,0,0,0-1.44,1.429v15A1.439,1.439,0,0,0,12.69,24.5h6.48V23.071H12.69v-15h2.16v2.143h8.64V8.071h2.16v7.857h1.44V8.071A1.439,1.439,0,0,0,25.65,6.643Zm-3.6,2.143H16.29V5.929h5.76Z",
    transform: "translate(-11.25 -4.5)",
    fill: "#868a97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskCompleted);
export default __webpack_public_path__ + "static/media/taskCompleted.b5a86fed67509c891d0ce8c20fd3da8c.svg";
export { ForwardRef as ReactComponent };